import { useTranslation } from 'react-i18next'
import { breakpoints } from '@/styles'
import { Wrapper } from '@/features/Application/elements'
import { showInfoModal, getModalInfo } from '@/features/Application/info-modal'
import { SectionTitle } from '@/features/Application/elements'
import useMediaQuery from '@/hooks/use-media-query'
import DesktopComponent from './desktop'
import MobileComponent from './mobile'
import Modal from './modal'

const View = ({
  data,
  application = {},
  isLocked,
  applicantFullName,
  hasUnlockCredits,
  isLoading,
  standalone
}) => {
  const { t } = useTranslation()

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const title = t('l.application.view.risk_assessment.label', 'Risk Assessment')
  const { trust_score = {} } = application ?? {}

  const showFloatingComponent =
    trust_score?.state === 'analyzing' || trust_score?.state === 'locked'
  const userName = application?.user_info?.first_name

  const isAnalyzing =
    trust_score?.risk_assessment?.court_verification === 'analyzing' ||
    trust_score?.risk_assessment?.potential_risks?.rate === 'analyzing' ||
    trust_score?.risk_assessment?.bankruptcy?.rate === 'analyzing' ||
    trust_score?.risk_assessment?.collection?.rate === 'analyzing'

  const { title: modalTitle, content } = getModalInfo('risk-assessment', t)
  const handleClick = () =>
    showInfoModal({
      title: modalTitle,
      content,
      isPoweredByEquifax: true
    })

  return (
    <Wrapper id="risk-assessment">
      {showFloatingComponent && (
        <Modal
          applicationId={application.id}
          applicantName={userName}
          state={trust_score?.state}
          status={trust_score?.status}
          hasUnlockCredits={hasUnlockCredits}
          applicantFullName={applicantFullName}
          standalone={standalone}
        />
      )}
      <SectionTitle
        title={title}
        handleInfoClick={handleClick}
        clickId="application-trust-score-info-risk"
        showInfo
        score={data?.score}
        maxScore={data?.max_score}
        rate={data?.rate}
        isLocked={isLocked}
        incompleteScore={isAnalyzing}
        isLoading={isLoading}
      />
      {isMobile ? (
        <MobileComponent
          data={data}
          application={application}
          isLocked={isLocked}
          isLoading={isLoading}
          standalone={standalone}
        />
      ) : (
        <DesktopComponent
          data={data}
          application={application}
          isLocked={isLocked}
          isAnalyzing={isAnalyzing}
          isLoading={isLoading}
          standalone={standalone}
        />
      )}
    </Wrapper>
  )
}

export default View
